import { cn } from "@/lib/utils";

export const ErrorText = ({
  className,
  errorMessage,
}: {
  className?: string;
  errorMessage: string;
}) => {
  return <p className={cn("text-red-500", className)}>{errorMessage}</p>;
};
